mainApp.component('comboBox', {
    templateUrl: '/public/components/combo-box.component.html',
    bindings: {
        field: '<', // a FieldsService.Field object or a collection
        presentationResolver: '&',
        trackBy: '@',
        selectAction: '&',
        removeAction: '&',
        autoComplete: '<',
        keepSelected: '<',
        comboId: '@',
        placeHolder: '@',
        selectedItems: '<', //  currently selected items to show as selected on the list
        showSelectedItems: '<',
        allowNotSuggestibleSelection: '<',
        scrollable: '<',
        doNotShowOptionsOnFieldsLoad: '<',
    },
    controller: function($scope, FieldsService, $state, IconsService, $timeout) {
        const ctrl = this;
        let currentValueModel;

        ctrl.id = 'combox-' + $scope.$id; // creating an id to use to identify the element in jquery selections
        ctrl.currentActiveSeaechItem = -1;
        ctrl.showOptions = false;
        ctrl.icons = IconsService.getIcons();
        ctrl.updateFromServer = false;

        $scope.$on('clear-combo', function(e, comboId) {
            if (comboId === ctrl.comboId) {
                clear();
            }
        });

        $scope.$on('close-combo', function(e, comboId) {
            if (comboId === ctrl.comboId) {
                closeOptions();
            }
        });

        ctrl.$onChanges = function(changed) {
            if (changed.field) {
                ctrl.updateFromServer = ctrl.field && !(ctrl.field instanceof Array);
            }

            if (changed.field || changed.selectedItems) {
                ctrl.updateAutoComplete(ctrl.selectedItems || []);
            }
        };

        ctrl.$onInit = ()=> {
            $timeout(()=> {
                let ComboBoxElement
                if (!ctrl.showSelectedItems) {
                    ComboBoxElement = document.getElementById(ctrl.id + '-search');
                } else {
                    ComboBoxElement = document.getElementById(ctrl.id );
                }
                ComboBoxElement.focus();
            },0,false);
        }

        ctrl.getPresentationLabel = function(item) {
            return ctrl.presentationResolver && ctrl.presentationResolver({item: item});
        }

        ctrl.showAutoComplete = function() {
            ctrl.updateAutoComplete(ctrl.selectedItems);
            ctrl.showOptions = true;
        };

        let requestTimeout;
        let requestFunction;

        ctrl.updateAutoComplete = function(selectedItems) {
            if (ctrl.autoComplete) {
                if (ctrl.updateFromServer) {
                    if (requestTimeout) {
                        $timeout.cancel(requestTimeout);
                    }

                    requestFunction = () => {
                        requestFunction = null;
                        FieldsService.search(ctrl.field, ctrl.currentValue, $state.params.accountId, function (data) {
                            if (!data) {
                                data = {
                                    items: []
                                }
                            }
                            ctrl.searchResults = data.items || data;
                            ctrl.currentActiveSearchItem = -1;
                            ctrl.showOptions = !ctrl.doNotShowOptionsOnFieldsLoad;
                            ctrl.pagination.total = data.total || ctrl.searchResults.length;
                            ctrl.pagination.calculatePages();
                            $scope.$digest();
                        }, ctrl.pagination.currentPage * ctrl.pagination.pageSize, ctrl.pagination.pageSize, ()=> {
                            console.log("error in request");
                        });
                    }
                    $timeout(requestFunction, 300, false);
                } else {
                    let searchValue = ctrl.currentValue ? ctrl.currentValue.toLowerCase() : null;
                    if (ctrl.showSelectedItems && selectedItems) {
                        if (searchValue) {
                            ctrl.searchResults = ctrl.field.filter((item) => ctrl.getPresentationName(item).toLowerCase().includes(searchValue) && selectedItems.indexOf(item) == -1);
                        } else {
                            ctrl.searchResults = ctrl.field.filter((item) => selectedItems.indexOf(item) == -1);
                        }
                    } else {
                        if (searchValue) {
                            ctrl.searchResults = ctrl.field.filter((item) => ctrl.getPresentationName(item).toLowerCase().includes(searchValue));
                        } else {
                            ctrl.searchResults = ctrl.field;
                        }
                    }

                    if (ctrl.allowNotSuggestibleSelection && searchValue) {
                        let currentlyTyped = {}
                        currentlyTyped[ctrl.trackBy] = ctrl.currentValue;
                        ctrl.searchResults.unshift(currentlyTyped);
                    }

                    ctrl.currentActiveSearchItem = -1;
                    ctrl.pagination.calculatePages();
                }
            }
        };

        ctrl.getPresentationName = function(item) {
            return ctrl.getPresentationLabel(item) || item.displayName || item.display_name || item.name  || item;
        }

        ctrl.keyDown = function($event) {
            if ($event.keyCode == 40) { // arrow down
                ctrl.currentActiveSearchItem++;
            } else if ($event.keyCode == 38) { // arrow up
                ctrl.currentActiveSearchItem--;
            } else if ($event.keyCode == 13) { // enter
                if (ctrl.allowNotSuggestibleSelection) {
                    let selected = {};

                    if (ctrl.currentActiveSearchItem > -1) { // selected something from the suggestion list
                        selected = ctrl.searchResults[ctrl.currentActiveSearchItem];
                    } else if (ctrl.currentValue) { // typed a value that is not in the suggestions list
                        selected[ctrl.trackBy] = ctrl.currentValue;
                    } else { // just pressed enter without any character typed
                        return;
                    }

                    ctrl.selectItem(selected, $event);

                    if (ctrl.showSelectedItems)
                        ctrl.currentValue = null;
                } else {
                    ctrl.selectItem(ctrl.searchResults[ctrl.currentActiveSearchItem], $event);
                }
            }
        };

        ctrl.toggleShowOptions = function() {
            ctrl.showOptions = !ctrl.showOptions;

            if (ctrl.showOptions) {
                if (!ctrl.searchResults) {
                    ctrl.updateAutoComplete(ctrl.selectedItems);
                }
                $('body').click(closeOptions);
                $scope.$emit('combo-box-open', ctrl.comboId)
            }
        };

        ctrl.isItemSelected = (item) =>{
            if (ctrl.selectedItems) {
                if (ctrl.trackBy) {
                    return ctrl.selectedItems.filter((selectedItem) => selectedItem[ctrl.trackBy] == item[ctrl.trackBy]).length > 0;
                } else {
                    return ctrl.selectedItems.filter((selectedItem) => selectedItem.id == item.id).length > 0;
                }
            }
        };

        function closeOptions($event) {
            // close options if the source of the close is a click outside of the combo
            if (/*ctrl.showOptions && */(!$event || $($event.target).parents('#' + ctrl.id).length === 0)) {
                ctrl.showOptions = false;
                ctrl.currentActiveSearchItem = -1;
                $('body').off('click', closeOptions);
                $scope.$root.ellipses = null;
            }
        }

        function clear() {
            ctrl.searchResults = null;
            closeOptions();
            ctrl.currentValue = null;
            currentValueModel = null;
            ctrl.pagination.restart();
        }

        ctrl.selectItem = function(item, $event) {
            if (item) {
                currentValueModel = item;
                ctrl.currentValue = ctrl.getPresentationName(item);
            } else {
                currentValueModel = null;
                ctrl.currentValue = null;
            }
            closeOptions();
            ctrl.addItem($event);
        };

        ctrl.removeItem = function(item, $event) {
            ctrl.removeAction({
                value: item,
                $event: $event
            });
        };

        ctrl.addItem = function($event) {
            if (!currentValueModel) {
                if (ctrl.currentActiveSearchItem >= 0) {
                    ctrl.selectItem(ctrl.searchResults[ctrl.currentActiveSearchItem]);
                } else {
                    if (!ctrl.currentValue) {
                        return;
                    }
                    const resultsForType = ctrl.searchResults.filter(function(item) {
                        return ctrl.currentValue === ctrl.getPresentationName(item);
                    });
                    if (resultsForType.length > 0) {
                        currentValueModel = resultsForType[0];
                    }
                }
            }

            ctrl.selectAction({
                value: currentValueModel,
                $event: $event
            });
            currentValueModel = null;

            // in case the component also presents all selected items the input should be empty
            // for next autocomplete and possible values should not contain the selected ones
            if (ctrl.showSelectedItems) {
                ctrl.currentValue = null;
            }

            closeOptions();
        };

        ctrl.pagination = {
            from: 0,
            pageSize: 7,
            currentPage: 0,
            total: 0,
            pages: [],
            totalPages: 0,
            next: function (reuseData) {
                if (this.currentPage + 1 === this.totalPages) {
                    return;
                }
                this.goTo(this.currentPage + 1, reuseData);
            },
            prev: function (reuseData) {
                if (this.currentPage === 0) {
                    return;
                }
                this.goTo(this.currentPage - 1, reuseData);
            },
            goTo: function (page, reuseData) {
                if (this.currentPage != page) {
                    this.currentPage = page;
                    if (reuseData) {
                        ctrl.pagination.calculatePages();
                    } else {
                        /*ctrl.queryId++;
                        ctrl.queryData(ctrl.queryId);*/
                        ctrl.updateAutoComplete(ctrl.selectedItems);
                    }
                }
            },
            calculatePages: function () {
                var i;
                var total = this.total;

                this.totalPages = Math.ceil(total / this.pageSize);
                var pagesToshowInPaginator = Math.min(5, (this.totalPages - this.currentPage) + 2);
                pagesToshowInPaginator = Math.min(pagesToshowInPaginator, this.totalPages);
                this.pages = [];
                if (this.currentPage <= 1) {
                    for (i = 0; i < pagesToshowInPaginator; i++) {
                        this.pages.push(i + 1);
                    }
                } else {
                    this.pages[0] = this.currentPage - 1;
                    for (i = 0; i < pagesToshowInPaginator - 1; i++) {
                        this.pages[i + 1] = this.currentPage + i;
                    }
                }

            },
            getPageClass: function (page) {
                var classStr = '';
                if (page === (this.currentPage + 1)) {
                    classStr += ' active ';
                }

                return classStr;
            },
            restart: function(){
                ctrl.pagination.from= 0;
                ctrl.pagination.pageSize= 10;
                ctrl.pagination.currentPage= 0;
                ctrl.pagination.total= 0;
                ctrl.pagination.pages= [];
                ctrl.pagination.totalPages= 0;
            }
        };

        ctrl.$onDestroy = function() {
            $('body').off('click', closeOptions);
        };
    }
});
